<template>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>LAUDO PSICOLÓGICO - Conceito e finalidade&nbsp;</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Estrutura</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§ 1º O laudo psicológico deve apresentar as informações da estrutura detalhada abaixo, em&nbsp;forma&nbsp;de&nbsp;itens.</strong></span></span
    >
  </p>
  <ol style="list-style-type: upper-roman">
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">O&nbsp;Laudo&nbsp;Psicológico&nbsp;é&nbsp;composto&nbsp;de&nbsp;6&nbsp;(seis)&nbsp;itens:</span></span>
      </p>
    </li>
  </ol>
  <ol style="list-style-type: lower-latin">
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Identificação;</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Descrição&nbsp;da&nbsp;demanda;</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Procedimento;</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Análise;</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Conclusão;</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Referências.</span></span>
      </p>
    </li>
  </ol>

  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Identificação</strong></span></span
    >
  </p>

  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§ 2º Neste item, a(o) psicóloga(o) deve fazer constar no documento:&nbsp;</strong></span></span
    >
  </p>
  <ol style="list-style-type: upper-roman">
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"
          ><span lang="PT" dir="ltr">Título: <strong>"Laudo&nbsp;Psicológico";</strong></span></span
        >
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Nome&nbsp;da&nbsp;pessoa&nbsp;ou&nbsp;instituição&nbsp;atendida:&nbsp;identificação&nbsp;do&nbsp;nome&nbsp;completo&nbsp;ou&nbsp;nome&nbsp;social&nbsp;completo&nbsp;e, quando&nbsp;necessário, outras&nbsp;informações sócio-demográficas;</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Nome do solicitante: identificação de quem solicitou o documento, especificando se a&nbsp;solicitação&nbsp;foi&nbsp;realizada&nbsp;pelo&nbsp;Poder&nbsp;Judiciário,&nbsp;por&nbsp;empresas,&nbsp;instituições&nbsp;públicas&nbsp;ou&nbsp;privadas,&nbsp;pelo&nbsp;próprio&nbsp;usuário&nbsp;do&nbsp;processo&nbsp;de&nbsp;trabalho&nbsp;prestado&nbsp;ou&nbsp;por&nbsp;outros&nbsp;interessados;</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Finalidade:&nbsp;descrição&nbsp;da&nbsp;razão&nbsp;ou&nbsp;motivo&nbsp;do&nbsp;pedido;</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Nome&nbsp;da(o)&nbsp;autora(or):&nbsp;identificação&nbsp;do&nbsp;nome&nbsp;completo&nbsp;ou&nbsp;nome&nbsp;social&nbsp;completo&nbsp;da(do)&nbsp;psicóloga(o) responsável pela construção do documento, com a respectiva inscrição no&nbsp;Conselho&nbsp;Regional de Psicologia.</span></span>
      </p>
    </li>
  </ol>

  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Descrição&nbsp;da&nbsp;demanda</strong></span></span
    >
  </p>

  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§ 3º Neste item, a(o) psicóloga(o), autora(or) do documento, deve descrever as informações&nbsp;sobre o que motivou a busca pelo processo de trabalho prestado, indicando quem forneceu as&nbsp;informações&nbsp;e as&nbsp;demandas&nbsp;que levaram&nbsp;à&nbsp;solicitação&nbsp;do&nbsp;documento.</strong></span></span
    >
  </p>
  <ol style="list-style-type: upper-roman">
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">A&nbsp;descrição&nbsp;da&nbsp;demanda&nbsp;constitui&nbsp;requisito&nbsp;indispensável&nbsp;e&nbsp;deverá&nbsp;apresentar&nbsp;o&nbsp;raciocínio&nbsp;técnico-científico que justificará procedimentos utilizados, conforme o parágrafo 4º deste&nbsp;artigo.</span></span>
      </p>
    </li>
  </ol>

  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Procedimento</strong></span></span
    >
  </p>

  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§ 4º Neste item, a(o) psicóloga(o) autora(or) do laudo deve apresentar o raciocínio técnico-&nbsp;científico que justifica o processo de trabalho realizado pela(o) psicóloga(o) e os recursos&nbsp;técnico-científicos&nbsp;utilizados&nbsp;no&nbsp;processo&nbsp;de&nbsp;avaliação&nbsp;psicológica,&nbsp;especificando&nbsp;o&nbsp;referencial&nbsp;teórico&nbsp;metodológico&nbsp;que fundamentou&nbsp;suas&nbsp;análises, interpretações&nbsp;e&nbsp;conclusões.</strong></span></span
    >
  </p>
  <ol style="list-style-type: upper-roman">
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">- Cumpre, à(ao) autora(or) do laudo, citar as pessoas ouvidas no processo de trabalho&nbsp;desenvolvido, as informações objetivas, o número de encontros e o tempo de duração do&nbsp;processo&nbsp;realizado.</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">-&nbsp;Os&nbsp;procedimentos&nbsp;adotados&nbsp;devem&nbsp;ser pertinentes&nbsp;à&nbsp;complexidade&nbsp;do&nbsp;que&nbsp;está&nbsp;sendo demandado e a(o) psicóloga(o) deve atender à Resolução CFP nº </span></span
        ><a target="_blank" rel="noopener noreferrer" href="https://atosoficiais.com.br/cfp/resolucao-do-exercicio-profissional-n-9-2018-estabelece-diretrizes-para-a-realizacao-de-avaliacao-psicologica-no-exercicio-profissional-da-psicologa-e-do-psicologo-regulamenta-o-sistema-de-avaliacao-de-testes-psicologicos-satepsi-e-revoga-as-resolucoes-n-0022003-n-006-2004-e-n-005-2012-e-notas-tecnicas-n-01-2017-e-02-2017?origin=instituicao"
          ><span style="color: blue; font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">09</span></span></a
        ><span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">/2018, ou outras que&nbsp;venham&nbsp;a&nbsp;alterá-la&nbsp;ou&nbsp;substituí-la.</span></span>
      </p>
    </li>
  </ol>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Análise</strong></span></span
    >
  </p>

  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§ 5º Nessa parte do documento, a(o) psicóloga(o) deve fazer uma exposição descritiva,&nbsp;metódica,&nbsp;objetiva&nbsp;e&nbsp;coerente&nbsp;com&nbsp;os&nbsp;dados&nbsp;colhidos&nbsp;e&nbsp;situações&nbsp;relacionadas&nbsp;à&nbsp;demanda&nbsp;em&nbsp;sua complexidade considerando a natureza dinâmica, não definitiva e não cristalizada do seu&nbsp;objeto&nbsp;de&nbsp;estudo.</strong></span></span
    >
  </p>
  <ol style="list-style-type: upper-roman">
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">- A&nbsp;análise&nbsp;não&nbsp;deve&nbsp;apresentar&nbsp;descrições&nbsp;literais&nbsp;das&nbsp;sessões&nbsp;ou&nbsp;atendimentos&nbsp;realizados,&nbsp;salvo&nbsp;quando&nbsp;tais&nbsp;descrições se&nbsp;justifiquem&nbsp;tecnicamente.</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">- Nessa exposição, deve-se respeitar a fundamentação teórica que sustenta o instrumental&nbsp;técnico utilizado, bem como os princípios éticos e as questões relativas ao sigilo das&nbsp;informações. Somente deve ser relatado o que for necessário para responder a demanda, tal&nbsp;qual&nbsp;disposto&nbsp;no&nbsp;Código&nbsp;de&nbsp;Ética&nbsp;Profissional do&nbsp;Psicólogo.</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">- A(o) psicóloga(o) não deve fazer afirmações sem sustentação em fatos ou teorias, devendo&nbsp;ter linguagem objetiva e precisa, especialmente quando se referir a dados de natureza&nbsp;subjetiva.</span></span>
      </p>
    </li>
  </ol>

  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Conclusão</strong></span></span
    >
  </p>

  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§&nbsp;6º&nbsp;Neste&nbsp;item,&nbsp;a(o)&nbsp;psicóloga(o)&nbsp;autora(or)&nbsp;do&nbsp;laudo&nbsp;deve&nbsp;descrever&nbsp;suas&nbsp;conclusões&nbsp;a&nbsp;partir&nbsp;do que foi relatado na análise, considerando a natureza dinâmica e não cristalizada do seu&nbsp;objeto&nbsp;de&nbsp;estudo.</strong></span></span
    >
  </p>
  <ol style="list-style-type: upper-roman">
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">- Na conclusão indicam-se os encaminhamentos e intervenções, diagnóstico, prognóstico e&nbsp;hipótese&nbsp;diagnóstica,&nbsp;evolução&nbsp;do&nbsp;caso,&nbsp;orientação&nbsp;ou&nbsp;sugestão&nbsp;de&nbsp;projeto&nbsp;terapêutico.</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">- O documento deve ser encerrado com indicação do local, data de emissão, carimbo, em&nbsp;que conste nome completo ou nome social completo da(o) psicóloga(o), acrescido de sua&nbsp;inscrição&nbsp;profissional,&nbsp;com&nbsp;todas&nbsp;as&nbsp;laudas&nbsp;numeradas,&nbsp;rubricadas&nbsp;da&nbsp;primeira&nbsp;até&nbsp;a&nbsp;penúltima&nbsp;lauda,&nbsp;e a&nbsp;assinatura&nbsp;da(o)&nbsp;psicóloga(o)&nbsp;na&nbsp;última&nbsp;página.</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">- É facultado&nbsp;à(ao)&nbsp;psicóloga(o)&nbsp;destacar,&nbsp;ao&nbsp;final&nbsp;do&nbsp;laudo,&nbsp;que&nbsp;este&nbsp;não&nbsp;poderá&nbsp;ser&nbsp;utilizado&nbsp;para fins diferentes do apontado no item de identificação, que possui caráter sigiloso, que se&nbsp;trata de documento extrajudicial e que não se responsabiliza pelo uso dado ao laudo por parte&nbsp;da&nbsp;pessoa,&nbsp;grupo&nbsp;ou&nbsp;instituição, após&nbsp;a&nbsp;sua&nbsp;entrega&nbsp;em entrevista&nbsp;devolutiva.</span></span>
      </p>
    </li>
  </ol>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Referências</strong></span></span
    >
  </p>

  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§ 7º Na elaboração de laudos, é obrigatória a informação das fontes científicas ou referências&nbsp;bibliográficas&nbsp;utilizadas, em&nbsp;nota&nbsp;de&nbsp;rodapé,&nbsp;preferencialmente.</strong></span></span
    >
  </p>
</template>
